import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter as routerCreateBrowserRouter, Navigate, } from 'react-router-dom';
import { LoadingBox, translate } from '@lucidlink/uicore';
import { wrapCreateBrowserRouterV7 } from '@lucidlink/workspacemanagement';
import { FatalError } from '@lucidlink/workspacemanagement/router/components';
import { MobileMain } from './MobileMain';
import { mobileChildRouteObjects } from './router';
const createBrowserRouter = wrapCreateBrowserRouterV7(routerCreateBrowserRouter);
// eslint-disable-next-line @typescript-eslint/naming-convention -- Providers is element type and must be capitalized
export const createMobileRouter = (Providers) => {
    return createBrowserRouter([
        {
            path: '/',
            element: (_jsx(Providers, { children: _jsx(MobileMain, {}) })),
            errorElement: _jsx(FatalError, {}),
            children: [...mobileChildRouteObjects],
            hydrateFallbackElement: (_jsx(LoadingBox, { alt: translate('Loading LucidLink'), "data-testid": 'loading-lucidlink', isFullHeight: true })),
        },
        {
            path: '*',
            element: _jsx(Navigate, { to: "/" }),
        },
    ]);
};
